import axios from 'axios';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { OctResponse } from '../../models/OctResponse';
import { APP_CONFIGURATION_KEYS } from '../../utils/Constant';
import { localStorageItem } from '../../utils/LocalStorage';

export const BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
	APP_CONFIGURATION_KEYS.API_URL
];

export const saveTransferInfo = async (params: any) => {
	const { data } = await axios.post<OctResponse<any>>(
		`${BASE_URL}/orders/transportation-info`,
		params
	);
    
	return data;
};
